// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { IReviewWeb } from '../../../node/repositories/newbuilding-card/entities/reviews/ReviewWeb';
import { IApplicationState } from '../../types/redux';

export const getReviewById = (id: string) => (state: IApplicationState) => {
  const reviews = state.newbuilding.reviews?.reviews;

  const review = reviews?.find(item => item.id === id) || null;

  return review as IReviewWeb;
};
